
export default (t) => [
  {
    text: t('Name'),
    value: 'name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Description'),
    value: 'description',
    sortable: false,
    width: 300,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
